export default __webpack_public_path__ + "static/media/4.03ad64f0.jpg";